const BASE = "orderHistoryPageLocators"

export const ORDER_HISTORY_PAGE_LOCATORS = {
  main: `${BASE}.main`,
  orderHistoryValue: `${BASE}.orderHistoryValue`,
  totalProfitLoss: `${BASE}.totalProfitLoss`,
}
